import React from 'react'

import './MessageBubble.css'

type Props = { message: React.ReactNode, avatar: React.ReactNode }
const MessageBubble: React.FC<Props> = ({ message, avatar }) => {
  return (
    <div className='inline message-bubble'>
      <div className='flex gap-x-2 md:gap-x-4 mb-5'>
        <div>{avatar}</div>
        <div className='text-black'>
          <p className='pt-1 whitespace-pre-line'>{message}</p>
        </div>
      </div>
    </div>
  )
}

export default MessageBubble
